import dayjs from "dayjs";
import Image from "components/imageNew/image";
import { TalkData } from "../types";

export const PastTalkCard = (props: TalkData) => {
  const img = props.summaryImage?.url
    ? props.summaryImage
    : props.image?.url
    ? props.image
    : null;

  return (
    <a href={props.eventRecordUrl || "#"}>
      <div className="h-[189px] bg-white p-[15px]">
        <div className="mb-2 flex justify-between">
          <div className="font-bold text-[14px]">{props.marketLabel}</div>
          <div className="text-[14px] text-mono-30">
            {dayjs(props.dateTime).format("DD.MM.YYYY")}
          </div>
        </div>
        <div className="flex justify-between gap-x-2">
          <p className="font-recklessBold text-[16px]">{props.title}</p>
          <div className="aspect-[120/91] max-w-[120px] overflow-hidden">
            {img && (
              <Image
                src={img.url}
                alt={img.alt || "Summary image"}
                blurDataURL={img.blurUpThumb}
                width={img.width}
                height={img.height}
                className={"object-contain object-right-top"}
              />
            )}
          </div>
        </div>
      </div>
    </a>
  );
};
